import { Component, inject } from '@angular/core';
import { SapMaterialGroupService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SapMaterialGroupCreateDto,
  SapMaterialGroupDto,
  SapMaterialGroupExcelDownloadDto,
  SapMaterialGroupUpdateDto,
} from '../proxy/controlling/dtos/sap-material-group';
import { SAPMATERIALGROUP_CONFIG, SAPMATERIALGROUP_FIELDS } from './sap-material-group.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sap-material-group',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SapMaterialGroupService, ConfirmationService],
  templateUrl: './sap-material-group.html',
  styleUrl: './sap-material-group.scss',
})
export class SapMaterialGroup extends BaseCrudComponent<
  SapMaterialGroupDto,
  SapMaterialGroupCreateDto,
  SapMaterialGroupUpdateDto,
  SapMaterialGroupExcelDownloadDto
> {
  service = inject(SapMaterialGroupService);
  config = SAPMATERIALGROUP_CONFIG;
  fields = SAPMATERIALGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: SapMaterialGroupDto): SapMaterialGroupUpdateDto {
    return {
      sapCode: data.sapCode,
      description: data.description,
      sapMaterialTypeId: data.sapMaterialTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SapMaterialGroup';
  }
}
